import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";
import axios from "axios";

export const studyEDCLupReportingServices = {
  //Lup Report Category
  addNewLupReportCategory,
  updateLupReportCategoryData,
  softDeleteRestoreLupReportCategory,
  getLupReportCategorysData,
  
  //Lup Report Metadata
  addNewLupReportMetadata,
  updateLupReportMetadatas,
  softDeleteRestoreLupReportMetadata,
  getLupReportMetadatasData,
  getSingleLupReportData,
  uploadFileinEDCLupDataLibrary,
  duplicateDataEDCLupFileAndDataset,
  updateDataLibraryFileAndDataset,
  softDeleteRestoreEDCLupData,
  getEDCLupDataLibrary,
  getEDCLupDatasetById,
  getEDCLupReportList,
  runGasEDCLupProcedureCode,

  syncEDCLupDataset,
};

// Get Lup Report Category
async function getLupReportCategorysData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getLupReportCategorysData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getLupReportCategorysData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Sync EDC Lup Dataset
async function syncEDCLupDataset(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}syncEDCLupDataset`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Run Gas EDC Lup Procedure Code
async function runGasEDCLupProcedureCode(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}runGasEDCLupProcedureCode`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Add New Lup Report Category
async function addNewLupReportCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewLupReportCategory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Lup Report Category
async function updateLupReportCategoryData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateLupReportCategoryData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Lup Report Category
async function softDeleteRestoreLupReportCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreLupReportCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Lup Report Metadata
async function getLupReportMetadatasData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getLupReportMetadatasData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getLupReportMetadatasData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Single Lup Report
async function getSingleLupReportData(type, reportId, studyId, mode) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSingleLupReportData/${type}/${reportId}/${studyId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get EDC Lup Dataset By Id
async function getEDCLupDatasetById(uniqueId, studyId, mode) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEDCLupDatasetById/${uniqueId}/${studyId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Lup Report Metadata
async function getEDCLupReportList(status, uniqueId, studyId, mode, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEDCLupReportList/${status}/${uniqueId}/${studyId}/${mode}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEDCLupReportList/${status}/${uniqueId}/${studyId}/${mode}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Lup Report Metadata
async function addNewLupReportMetadata(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewLupReportMetadata`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Lup Report Metadata
async function updateLupReportMetadatas(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateLupReportMetadatas`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Lup Report Metadata
async function softDeleteRestoreLupReportMetadata(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreLupReportMetadata`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Upload and Save Library Data
async function uploadFileinEDCLupDataLibrary(formData) {
  try {
    const response = await axios.post(
      `${config.API_URL_USER_ONBOARDING}uploadFileinEDCLupDataLibrary`,
      formData,
      {
        headers: {
          Authorization: headers.authorization,
        },
      }
    );
    const data = response?.data;
    handleResponse(data);
    return data;
  } catch (error) {
    const errData = error.response?.data || { message: error.message };
    handleResponse(errData);
    return errData;
  }
}

// Duplicate File Dataset Name & data
async function duplicateDataEDCLupFileAndDataset(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}duplicateDataEDCLupFileAndDataset`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Move File Dataset Name & data
async function updateDataLibraryFileAndDataset(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateDataLibraryFileAndDataset`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Soft Delete & Restore EDC Lup Data
async function softDeleteRestoreEDCLupData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreEDCLupData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Lup Data Library
async function getEDCLupDataLibrary(status, studyId, mode, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEDCLupDataLibrary/${status}/${studyId}/${mode}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEDCLupDataLibrary/${status}/${studyId}/${mode}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}